export const setHeaderCheck = (state, value) => {
    state.headerCheck = value
}